var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "basket-list-item py-3" },
    [
      _vm._t("before-basket-item"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "basket-item component-loading with-icon d-flex",
          class: {
            "sending is-loading": _vm.waiting,
            "is-loading": _vm.isCheckoutReadonly,
          },
        },
        [
          _c("div", { staticClass: "image-container" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm._f("itemURL")(_vm.basketItem.variation.data),
                },
              },
              [
                _vm.image
                  ? _c("lazy-img", {
                      attrs: {
                        "picture-class": "d-block mw-100 mh-100",
                        "image-url": _vm.image,
                        alt: _vm.altText,
                        title: _vm.itemName,
                        "data-testing": "basket-item-img",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "meta-container-wrapper" },
            [
              _c("div", { staticClass: "meta-container-wrapper-inner" }, [
                _c("div", { staticClass: "meta-container" }, [
                  _c(
                    "div",
                    { staticClass: "position-relative w-100" },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "item-name text-primary text-appearance small font-weight-bold text-break",
                          attrs: {
                            href: _vm._f("itemURL")(
                              _vm.basketItem.variation.data
                            ),
                            "data-testing": "basket-item-name",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("itemName")(
                                  _vm.basketItem.variation.data
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-base-price small" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm._f("currency")(_vm.unitPrice)) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("item-bundle", {
                        attrs: {
                          "bundle-type":
                            _vm.basketItem.variation.data.variation.bundleType,
                          "bundle-components":
                            _vm.basketItem.variation.data.bundleComponents,
                        },
                      }),
                      _vm._v(" "),
                      !(
                        _vm.basketItem.variation.data.unit.unitOfMeasurement ===
                          "C62" &&
                        _vm.basketItem.variation.data.unit.content === 1
                      ) &&
                      _vm.basketItem.variation.data.variation.mayShowUnitPrice
                        ? _c("div", { staticClass: "text-muted small" }, [
                            _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.basePrice) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.basketContent"
                                    )
                                  ) + ": "
                                ),
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.basketItem.variation.data.unit.content
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.basketItem.variation.data.unit.names
                                      .name
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.basketItem.inputLength > 0 ||
                      _vm.basketItem.inputWidth > 0
                        ? _c("div", { staticClass: "small" }, [
                            _c("div", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate("Ceres::Template.itemInput")
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm._f("inputUnit")(_vm.basketItem, true)
                                    ) +
                                    ": "
                                ),
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm._f("inputUnit")(_vm.basketItem)) +
                                  "\n                            "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "small" },
                        _vm._l(
                          _vm.basketItem.variation.data.attributes,
                          function (attribute) {
                            return _c("div", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(attribute.attribute.names.name) + ": "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(attribute.value.names.name)),
                              ]),
                            ])
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-muted small" },
                        [
                          _vm._l(
                            _vm.basketItem.variation.data.variationProperties,
                            function (propertyGroup) {
                              return _vm._l(
                                propertyGroup.properties,
                                function (property) {
                                  return _c(
                                    "div",
                                    [
                                      propertyGroup.name
                                        ? _c("strong", [
                                            _vm._v(
                                              _vm._s(propertyGroup.name) + ": "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(property.names.name)),
                                      ]),
                                      _vm._v(" "),
                                      property.cast === "file"
                                        ? _c("span", [
                                            _c("a", {
                                              attrs: {
                                                href: _vm._f("propertyFileUrl")(
                                                  property.values.value
                                                ),
                                                target: "_blank",
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  property.values.value
                                                ),
                                              },
                                            }),
                                          ])
                                        : property.cast === "multiSelection" &&
                                          property.values[0] !== undefined
                                        ? [
                                            _c(
                                              "ul",
                                              { staticClass: "pl-3" },
                                              _vm._l(
                                                property.values,
                                                function (multiSelectProperty) {
                                                  return _c("li", [
                                                    _vm._v(
                                                      _vm._s(
                                                        multiSelectProperty.value
                                                      )
                                                    ),
                                                  ])
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        : _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                property.values.value
                                              ),
                                            },
                                          }),
                                    ],
                                    2
                                  )
                                }
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "basket-item-container-right" }, [
                  _c(
                    "div",
                    { staticClass: "qty-box-container" },
                    [
                      _c("quantity-input", {
                        attrs: {
                          value: _vm.basketItem.quantity,
                          waiting: _vm.isInputLocked || _vm.isCheckoutReadonly,
                          min: _vm.basketItem.variation.data.variation
                            .minimumOrderQuantity,
                          max: _vm.basketItem.variation.data.variation
                            .maximumOrderQuantity,
                          interval:
                            _vm.basketItem.variation.data.variation
                              .intervalOrderQuantity,
                        },
                        on: { "quantity-change": _vm.updateQuantity },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "price-box text-right ml-2 mt-1" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "item-total-price font-weight-bold text-nowrap",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.basketItem.quantity * _vm.unitPrice,
                              _vm.basketItem.variation.data.prices.default
                                .currency
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm text-danger p-0",
                        class: {
                          disabled:
                            _vm.waiting ||
                            _vm.isBasketLoading ||
                            _vm.isCheckoutReadonly ||
                            _vm.waitingForDelete,
                        },
                        attrs: { "data-testing": "basket-item-delete" },
                        on: { click: _vm.deleteItem },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.basketDelete")
                            ) +
                            "\n                            "
                        ),
                        _c("icon", {
                          staticClass: "default-float",
                          attrs: {
                            icon: "trash-o",
                            loading: _vm.waitingForDelete,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.basketItem.setComponents
                ? _c("basket-set-component-list", {
                    attrs: {
                      "set-components": _vm.basketItem.setComponents,
                      "set-item": _vm.basketItem,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("order-property-value-list", {
                attrs: { "basket-item": _vm.basketItem },
              }),
              _vm._v(" "),
              _vm.showMoreInformation
                ? _c(
                    "div",
                    { staticClass: "small" },
                    [
                      _vm.isDataFieldVisible("basket.item.item_id") &&
                      _vm.basketItem.variation.data.item.id
                        ? [
                            _c("div", { staticClass: "mt-3" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.basketItemId"
                                    )
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.basketItem.variation.data.item.id)
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDataFieldVisible("basket.item.customNumber")
                        ? [
                            _vm.basketItem.variation.data.variation.number
                              ? _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.basketItemNumber"
                                        )
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.basketItem.variation.data.variation
                                          .number
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDataFieldVisible("basket.item.availability")
                        ? [
                            _vm.basketItem.variation.data.variation
                              .availability &&
                            _vm.basketItem.variation.data.variation.availability
                              .names.name
                              ? _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.basketAvailability"
                                        )
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.basketItem.variation.data.variation
                                          .availability.names.name
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDataFieldVisible("basket.item.description_long")
                        ? [
                            _vm.basketItem.variation.data.texts.description
                              ? _c("p", {
                                  staticClass: "my-3",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.basketItem.variation.data.texts
                                        .description
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDataFieldVisible("basket.item.description_short")
                        ? [
                            _vm.basketItem.variation.data.texts.shortDescription
                              ? _c("p", {
                                  staticClass: "my-3",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.basketItem.variation.data.texts
                                        .shortDescription
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMoreButtonVisible
                ? _c("label", {
                    staticClass: "btn-collapse",
                    class: { collapsed: !_vm.showMoreInformation },
                    attrs: {
                      "data-show-more": _vm.$translate(
                        "Ceres::Template.basketShowMore"
                      ),
                      "data-show-less": _vm.$translate(
                        "Ceres::Template.basketShowLess"
                      ),
                    },
                    on: {
                      click: function ($event) {
                        _vm.showMoreInformation = !_vm.showMoreInformation
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm._t("after-basket-item"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }